/*
 * Ryan O'Dowd
 * 2025-06-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const InAppReview = {
  RequestInAppReview: () => Promise.resolve(true),
};

export default InAppReview;
